import angular from 'angular';
import scenes from './scenes';
import insuranceCustomerCare from './insuranceCustomerCare';
import './style.scss';

export default angular
  .module('scenes.insuranceCustomerCare', [scenes])
  .component('insuranceCustomerCare', insuranceCustomerCare).name;
